const state = {
}

const getters = {
}

const mutations = {
}

function splitRequestParams (params = {}) {
  const {
    config = {},
    ...requestParams
  } = params
  return {
    config,
    requestParams,
  }
}

const actions = {
  prepare ({ state, commit, rootState }, params = {}) {
    const { config, requestParams } = splitRequestParams(params)
    return rootState.axios.get('/wallet/preorder/v1frontend/preorder/prepare', {
      ...config,
      params: requestParams,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  index ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/preorder/v1frontend/preorder/index', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  updateCanceled ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/preorder/v1frontend/preorder/update-canceled', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/preorder/v1frontend/preorder/create', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  matchTxntw ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/preorder/v1frontend/preorder/match-txntw', params)
  },
  view ({ state, commit, rootState }, params) {
    return rootState.axios.get('/wallet/preorder/v1frontend/preorder/view', {
      params,
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  updateAmountLast ({ state, commit, rootState }, params) {
    return rootState.axios.post('/wallet/preorder/v1frontend/preorder/update-amount-last', params, {
      baseURL: window.G_BASEURL.API_KKREN_BASE_URL
    })
  },
  fetchUnpayOrder ({ dispatch }) {
    return dispatch('index', {
      page: 1,
      pageSize: 1
    }).then(res => {
      if (res.data.list.length && res.data.list[0].porStatus === '1') {
        return res.data.list[0]
      }
      return null
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
